/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RenderConditionFromJSON, RenderConditionToJSON } from './RenderCondition';
import { ResourceAuthorizationRuleFromJSON, ResourceAuthorizationRuleToJSON } from './ResourceAuthorizationRule';
import { CreateZoneFromJSON, CreateZoneToJSON } from './CreateZone';

/**
 * 
 * @export
 * @interface CreateBlock
 */

/**
 * Check if a given object implements the CreateBlock interface.
 */
export function instanceOfCreateBlock(value) {
  if (!('blockName' in value) || value['blockName'] === undefined) return false;
  return true;
}
export function CreateBlockFromJSON(json) {
  return CreateBlockFromJSONTyped(json, false);
}
export function CreateBlockFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'parentZoneRID': json['parentZoneRID'] == null ? undefined : json['parentZoneRID'],
    'blockRID': json['blockRID'] == null ? undefined : json['blockRID'],
    'id': json['id'] == null ? undefined : json['id'],
    'pluginId': json['pluginId'] == null ? undefined : json['pluginId'],
    'blockName': json['blockName'],
    'blockParameters': json['blockParameters'] == null ? undefined : json['blockParameters'],
    'zones': json['zones'] == null ? undefined : json['zones'].map(CreateZoneFromJSON),
    'condition': json['condition'] == null ? undefined : RenderConditionFromJSON(json['condition']),
    'foreach': json['foreach'] == null ? undefined : json['foreach'],
    'as': json['as'] == null ? undefined : json['as'],
    'authorize': json['authorize'] == null ? undefined : json['authorize'].map(ResourceAuthorizationRuleFromJSON)
  };
}
export function CreateBlockToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'parentZoneRID': value['parentZoneRID'],
    'blockRID': value['blockRID'],
    'id': value['id'],
    'pluginId': value['pluginId'],
    'blockName': value['blockName'],
    'blockParameters': value['blockParameters'],
    'zones': value['zones'] == null ? undefined : value['zones'].map(CreateZoneToJSON),
    'condition': RenderConditionToJSON(value['condition']),
    'foreach': value['foreach'],
    'as': value['as'],
    'authorize': value['authorize'] == null ? undefined : value['authorize'].map(ResourceAuthorizationRuleToJSON)
  };
}